import Vue from "vue";
import Vuex, { Module } from "vuex";
import branch from "./branch";
import sale from "./sale";
import catalog from "./catalog";
import search from "./search";
import allProduct from "./allProduct";
import cart from "./cart";
import activeCustomer from "./activeCustomer";
import cartData from "./cartData";
import checkout from "./checkout";
import createPersistedState from "vuex-persistedstate";
import order from "./order";
import admin from "./admin";
import customerChat from "./customerChat";
import chat from "./chat";
import customerStat from "./customerStat";

Vue.use(Vuex);

const persistedState = createPersistedState({
  paths: ["branch"],
});

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    branch: branch as Module<any, any>,
    sale: sale as Module<any, any>,
    catalog: catalog as Module<any, any>,
    search: search as Module<any, any>,
    allProduct: allProduct as Module<any, any>,
    cart: cart as Module<any, any>,
    activeCustomer: activeCustomer as Module<any, any>,
    cartData: cartData as Module<any, any>,
    checkout: checkout as Module<any, any>,
    order: order as Module<any, any>,
    admin: admin as Module<any, any>,
    customerChat: customerChat as Module<any, any>,
    chat: chat as Module<any, any>,
    customerStat: customerStat as Module<any, any>,
  },
  plugins: [persistedState],
});
